import { PaginationRequest } from '@repo/ui/data-table'

import { AffectedStaffLight } from '../../lib/types/models/affectedStaff/affected-staff'
import { TripFolderPassengersFilters } from '../../lib/types/models/trip-folder/trip-folder-passengers'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolderAffectedStaffs(
  id: number,
  input?: PaginationRequest<TripFolderPassengersFilters>
) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest<TripFolderPassengersFilters>>(
        constructApiUrl(API.tripFolder.getAffectedStaffs.url, { id }),
        input
      )
    )
    .get<AffectedStaffLight[]>()
}
